// @ts-nocheck
/**
 * Support Redux Sagas
 */

import { call, put, select, takeLatest } from 'redux-saga/effects'
import type { PayloadAction } from '@reduxjs/toolkit'
import { supportApi } from '../infrastructure/api/support-api'
import { supportActions } from './support.slice'
import type { CreateTicketPayload } from './support.slice'
import type {
  SupportTicket,
  SupportTicketsFilter,
  PaginatedSupportTickets,
  UpdateSupportTicketRequest,
} from '../domain/types'

function* fetchTicketsSaga(action: PayloadAction<SupportTicketsFilter | undefined>) {
  try {
    const filter = action.payload ?? (yield select((state: any) => state.support?.filter))
    const result: PaginatedSupportTickets = yield call(supportApi.getTickets, filter)
    yield put(supportActions.fetchTicketsSuccess(result))
  } catch (error) {
    yield put(supportActions.fetchTicketsFailure((error as Error).message))
  }
}

function* createTicketSaga(action: PayloadAction<CreateTicketPayload>) {
  try {
    const { attachmentFiles, ...ticketData } = action.payload

    let attachmentIds: number[] = []
    if (attachmentFiles && attachmentFiles.length > 0) {
      attachmentIds = yield call(supportApi.uploadFiles, attachmentFiles)
    }

    const payload = attachmentIds.length > 0
      ? { ...ticketData, attachments: attachmentIds }
      : ticketData

    const ticket: SupportTicket = yield call(supportApi.createTicket, payload)
    yield put(supportActions.createTicketSuccess(ticket))
    // Re-fetch list to get accurate data
    const filter: SupportTicketsFilter = yield select((state: any) => state.support?.filter)
    yield put(supportActions.fetchTickets(filter))
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.error?.message ||
      error?.message ||
      'Failed to create support ticket'
    yield put(supportActions.createTicketFailure(errorMessage))
  }
}

function* updateTicketSaga(action: PayloadAction<{ id: string } & UpdateSupportTicketRequest>) {
  try {
    const { id, ...updates } = action.payload
    const ticket: SupportTicket = yield call(supportApi.updateTicket, id, updates)
    yield put(supportActions.updateTicketSuccess(ticket))
    // Re-fetch list to reflect changes in table
    const filter: SupportTicketsFilter = yield select((state: any) => state.support?.filter)
    yield put(supportActions.fetchTickets(filter))
  } catch (error) {
    yield put(supportActions.updateTicketFailure((error as Error).message))
  }
}

export function* supportSaga() {
  yield takeLatest(supportActions.fetchTickets.type, fetchTicketsSaga)
  yield takeLatest(supportActions.createTicket.type, createTicketSaga)
  yield takeLatest(supportActions.updateTicket.type, updateTicketSaga)
}
